import { createFileRoute } from "@tanstack/react-router";
import { EventDetailPage } from "@/features/event-explorer/components/EventDetailPage";
import { isSafeInternalPath } from "@/lib/navigation/userProfileNavigation";

type EventDetailSearch = {
  from?: string;
};

export const Route = createFileRoute("/event-search/$event-id")({
  component: EventDetailPage,
  validateSearch: (search: Record<string, unknown>): EventDetailSearch => ({
    from: isSafeInternalPath(search.from) ? search.from : undefined,
  }),
  loader: ({ params }) => {
    return { eventId: params["event-id"] };
  },
});
